<!--  -->
<template>
  <div class="topbar-container">
  </div>
</template>

<script>
import { Dialog } from "vant";
export default {
  data() {
    return {};
  },
  async created() {
    await Dialog.alert({
      title: "提示",
      message: "该活动已结束"
    });
    window.location.href = "https://xbcf.hechaji.com/xbcf"
  }
};
</script>
<style scoped>
/* @import url(); 引入css类 */
</style>